import React, { useContext } from 'react';
import { GenericRoundTable, SHAPE, SeatingViewerContext } from '@wix/seating-common-components';
import { WholeTableReservationWrapper } from '../whole-table-reservation-wrapper';
export const RoundTable = ({ definition }) => {
    var _a, _b;
    const { shapeTypeConfig } = useContext(SeatingViewerContext);
    const { hideSeats = false, forcedCursor = {}, perShapeConfig } = (_a = shapeTypeConfig[SHAPE.ROUND_TABLE]) !== null && _a !== void 0 ? _a : {};
    const { fillColor, strokeColor, color } = (_b = (perShapeConfig !== null && perShapeConfig !== void 0 ? perShapeConfig : {})[definition.id]) !== null && _b !== void 0 ? _b : {};
    return (React.createElement(WholeTableReservationWrapper, { definition: definition },
        React.createElement(GenericRoundTable, { definition: definition, hideSeats: hideSeats, fillColor: fillColor, strokeColor: strokeColor, color: color, forcedCursor: forcedCursor })));
};
//# sourceMappingURL=round-table.js.map